// ============================================================
// Teacher Homework Mock Data
// ============================================================

export const mockTeacherHomework = [
  {
    id: 'hw-1',
    teacherId: 'teacher-1',
    schoolId: 'school-1',
    classId: 'class-1',
    className: 'Grade 1',
    sectionId: 'sec-1',
    sectionName: 'Section A',
    subject: 'Mathematics',
    title: 'Addition & Subtraction Practice',
    description: 'Complete exercises 1 to 15 on page 42 of the Math workbook.',
    attachment: null,
    submissionDate: '2026-07-25',
    status: 'active',
    createdAt: '2026-07-21T10:00:00Z',
  },
  {
    id: 'hw-2',
    teacherId: 'teacher-1',
    schoolId: 'school-1',
    classId: 'class-1',
    className: 'Grade 1',
    sectionId: 'sec-2',
    sectionName: 'Section B',
    subject: 'Mathematics',
    title: 'Number Patterns',
    description: 'Solve the number pattern worksheet provided in class today.',
    attachment: 'number_patterns_ws.pdf',
    submissionDate: '2026-07-24',
    status: 'active',
    createdAt: '2026-07-20T14:30:00Z',
  },
  {
    id: 'hw-3',
    teacherId: 'teacher-2',
    schoolId: 'school-1',
    classId: 'class-2',
    className: 'Grade 2',
    sectionId: 'sec-3',
    sectionName: 'Section A',
    subject: 'Science',
    title: 'Parts of a Plant',
    description: 'Draw a plant and label its different parts. Use colors.',
    attachment: null,
    submissionDate: '2026-07-26',
    status: 'active',
    createdAt: '2026-07-21T09:15:00Z',
  },
  {
    id: 'hw-4',
    teacherId: 'teacher-3',
    schoolId: 'school-1',
    classId: 'class-3',
    className: 'Grade 3',
    sectionId: 'sec-1',
    sectionName: 'Section A',
    subject: 'English',
    title: 'Creative Writing: My Summer Vacation',
    description: 'Write a 150-word essay about how you spent your summer vacation.',
    attachment: null,
    submissionDate: '2026-07-28',
    status: 'active',
    createdAt: '2026-07-21T11:45:00Z',
  }
];
